"use client";

import { useState, FormEvent } from "react";
import { useRouter } from "next/navigation";

import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuthStore } from "@/stores/useAuthStore";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const login = useAuthStore((s) => s.login);
  const router = useRouter();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(username, password);
      router.push("/");
    } catch {
      setError("Sisse logimine ebaõnnestus");
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center bg-background mt-4">
      <form
        onSubmit={handleSubmit}
        className="w-full border max-w-sm space-y-6 bg-card p-6 rounded-lg shadow-lg"
      >
        <h1 className="text-2xl font-semibold text-center">Logi sisse</h1>

        {error && (
          <p className="text-sm text-destructive text-center">{error}</p>
        )}

        <div>
          <Label htmlFor="username">Kasutajanimi</Label>
          <Input
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value.trim())}
            required
            autoFocus
          />
        </div>

        <div>
          <Label htmlFor="password">Parool</Label>
          <Input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <Button type="submit" className="w-full" disabled={loading}>
          Logi sisse
        </Button>
      </form>
    </div>
  );
}
